import { format } from 'date-fns'

import { timeAgoFromToday } from '@avantstay/backoffice-core'
import { IconAlertTriangle } from '@avantstay/backoffice-vectors'

import { clipText } from '@new/domains/operations/utils/text'

import { GuestInboxStayDetail, GuestInboxTimelineEvent } from '../../StayTimeline.types'
import { getLastGuestEvent, toDate } from '../../StayTimeline.utils'
import * as S from './ConflictCard.styles'

interface ConflictCardProps {
  conflict: string
  topCase?: GuestInboxStayDetail['cases']['top']
  conversation: GuestInboxTimelineEvent[]
}

const GUEST_CLIP = 220

export const ConflictCard = ({ conflict, topCase, conversation }: ConflictCardProps) => {
  const raised = getLastGuestEvent(conversation)
  const raisedAt = toDate(raised?.at)
  const openedAt = toDate(topCase?.openedAt)

  return (
    <S.Root>
      <S.Head>
        <IconAlertTriangle />
        <S.Headline>{conflict}</S.Headline>
      </S.Head>

      <S.Facts>
        {raised ? (
          <S.Fact>
            <S.FactTitle>What the guest said</S.FactTitle>
            {raisedAt ? ` · ${format(raisedAt, 'h:mm a')}` : ''}
            <br />“{clipText(raised.body, GUEST_CLIP)}”
          </S.Fact>
        ) : null}

        {topCase ? (
          <S.Fact>
            <S.FactTitle>What the case record says</S.FactTitle>
            <br />
            {topCase.categoryLabel} · {topCase.status || 'open'}
            {openedAt ? ` · ${timeAgoFromToday(openedAt)}` : ''}
          </S.Fact>
        ) : null}
      </S.Facts>
    </S.Root>
  )
}
